import { useMsal } from "@azure/msal-react";

import { apiFetch, ApiError } from "@/auth/api";
import { BYPASS_AUTH, MOCK_USER } from "@/auth/devBypass";
import type { Papel } from "@/types/api";
import { useQuery } from "@tanstack/react-query";

export interface MeResponse {
  id: string;
  upn: string;
  nome: string;
  papel: Papel;
  local_id: string | null;
}

/**
 * Retorna o usuário corrente provisionado no Med-Supply (linha em `usuario`).
 *
 * - Em ambiente Azure: chama GET /me com bearer Entra.
 * - Em BYPASS_AUTH com API local: chama GET /me com o DEV_BYPASS_TOKEN.
 *   Se API não está rodando, cai no MOCK_USER pra não travar a UI.
 */
export function useUser() {
  const { accounts } = useMsal();
  const logged = accounts.length > 0;
  return useQuery<MeResponse>({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await apiFetch<MeResponse>("/me");
      } catch (e) {
        if (BYPASS_AUTH && (e instanceof ApiError || e instanceof TypeError)) {
          return MOCK_USER;
        }
        throw e;
      }
    },
    enabled: BYPASS_AUTH || logged,
    staleTime: 5 * 60_000,
    retry: false,
  });
}

export function useHasRole(...allowed: Papel[]): boolean {
  const { data } = useUser();
  return !!data && allowed.includes(data.papel);
}
